
import { Link } from "react-router-dom";

const Home = () => {
  return (
    <div className="container">
      <h1>Attendance App</h1>
      <Link to="/create">
        <button>Create New Form</button>
      </Link>
      <button>Access Form (Coming Soon)</button>
    </div>
  );
};

export default Home;
